import { boot } from '@poa/core';
import { useStrict } from '@poa/state';

import moment from 'moment';

import 'moment/locale/ru';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import 'react-tippy/dist/tippy.css';
import './app.css';

import { routes } from './routes';
import { env } from './env';
import { initialState } from './store/initial-state';
import * as actions from './store';

import ru from './locales/ru';

import registerServiceWorker from './registerServiceWorker';

useStrict(false);

const locale = 'ru-RU';
export const version = "0.8.9";

async function bootstrap() {
  // use service workers for faster reloads on prod
  registerServiceWorker();
  // set default moment locale
  moment.locale(locale);

  // boot application with poa
  await boot({
    react: { htmlNode: document.getElementById('root') },
    router: { type: 'browser', routes },
    state: { initial: initialState, actions },
    env,
    i18n: {
      lng: locale,
      resources: { ru }
    }
  });
}

bootstrap().catch(error => console.error(error));
